import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Box } from "@material-ui/core";

import "./TabsErp.css";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      flexGrow: 1,
      width: "100%",
    },
    selected: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      opacity: "1",
    },
    enable: {
      opacity: "0.8",
    },
    disabled: {
      opacity: "0.5",
    },
    error: {
      color: "#FA8072",
      fontWeight: "bold",
      opacity: "1",
    },
  };
});

const TabsErp = function ({
  headers,
  children,
  position = "static",
  backgroundColor = "inherit",
  changeTab,
  tabIndex,
  paddingInside = 3,
  classNameRoot,
  classNameTabEnable,
  classNameTabDisabled,
  contentClassName = "",
  marginChildrenToTop = 20,
  ...props
}) {
  const classes = useStyles();

  return (
    <div
      key={"TabsErpDiv"}
      className={classNameRoot ? classNameRoot : classes.root}
    >
      <AppBar key="TabsErpAppBar" position={position} color={backgroundColor}>
        <Tabs
          key="TabsErp"
          value={tabIndex}
          onChange={changeTab}
          {...props}
          variant="scrollable"
          scrollButtons="on"
        >
          {headers.map((headerValue, index) => {
            let classe = classes.selected;
            if (tabIndex !== index)
              classe = classNameTabEnable ? classNameTabEnable : classes.enable;
            if (headerValue.disabled)
              classe = classNameTabDisabled
                ? classNameTabDisabled
                : classes.disabled;

            if (headerValue?.error) {
              classe = classes.error;
            }

            return (
              <Tab
                id={`tabErp-${index}`}
                key={`tabErp-${index}`}
                aria-controls={`tabErpPanel-${index}`}
                className={classe}
                {...headerValue}
              />
            );
          })}
        </Tabs>
      </AppBar>
      {children.map((child, index) => {
        return (
          <div
            className={contentClassName}
            key={`tabErpPanel-item-${index}`}
            id={`tabErpPanel-item-${index}`}
            role="tabpanel"
            hidden={tabIndex !== index}
            aria-labelledby={`tabErp-item-${index}`}
            style={{
              borderWidth: "5px",
            }}
            {...props}
          >
            {tabIndex === index && (
              <Box style={{ marginTop: marginChildrenToTop }}>{child}</Box>
            )}
          </div>
        );
      })}
    </div>
  );
};

TabsErp.propTypes = {
  headers: PropTypes.array.isRequired,
  children: PropTypes.array.isRequired,
};

export default TabsErp;
